// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Info: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15.174" height="16.989" viewBox="0 0 15.174 16.989">
            <g fillRule="evenodd">
                <path d="M7.58699809,1.0617849 C11.2382409,1.0617849 14.2256214,4.40640732 14.2256214,8.49427918 C14.2256214,12.582151 11.2382409,15.9267735 7.58699809,15.9267735 C3.93575526,15.9267735 0.948374761,12.582151 0.948374761,8.49427918 C0.948374761,4.40640732 3.93575526,1.0617849 7.58699809,1.0617849 L7.58699809,1.0617849 Z M7.58699809,0 C3.41414914,0 0,3.82242563 0,8.49427918 C0,13.1661327 3.41414914,16.9885584 7.58699809,16.9885584 C11.759847,16.9885584 15.1739962,13.1661327 15.1739962,8.49427918 C15.1739962,3.82242563 11.759847,0 7.58699809,0 L7.58699809,0 L7.58699809,0 Z" />
                <polygon points="8.851 7.079 5.69 7.079 5.69 8.494 6.955 8.494 6.955 11.326 5.69 11.326 5.69 12.741 10.116 12.741 10.116 11.326 8.851 11.326" />
                <ellipse cx="7.903" cy="5.309" rx="1" ry="1.062" />
            </g>
        </svg>
    );
};

export default React.memo(Info);
